import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class StudioService {
  private api = inject(ApiService);

  list(scope: string = 'all'): Promise<any> {
    const path = scope === 'all' ? '/studio' : `/studio/${scope}`;
    return this.api.get(path);
  }

  getTransaction(id: number | string, year: number | string, month: number | string): Promise<any> {
    return this.api.get(`/studio/${id}/transaction/${year}/${month}`);
  }

  getProduct(id: number | string): Promise<any> {
    return this.api.get(`/studio/${id}/product`);
  }
}
